__turbopack_context__.v({
  "banner": "styles-module-scss-module__MLo2DG__banner",
  "banner_close": "styles-module-scss-module__MLo2DG__banner_close",
  "banner_content": "styles-module-scss-module__MLo2DG__banner_content",
  "banner_dismissing": "styles-module-scss-module__MLo2DG__banner_dismissing",
  "banner_event": "styles-module-scss-module__MLo2DG__banner_event",
  "banner_outage": "styles-module-scss-module__MLo2DG__banner_outage",
  "banner_wrapper": "styles-module-scss-module__MLo2DG__banner_wrapper",
});
